import { ycrType } from "../../../constant";


const ycrReducer = (state = false, action) => {
    switch (action.type) {
        case ycrType.FETCH_INTEREST_RATES_DATA_TYPES:
            return action.payload;
        default:
            return state;
    }
}
export default ycrReducer